import WebView from "@/Layouts/WebView";
import {Head, useForm, usePage} from "@inertiajs/inertia-react";
import ProductLogo from "@/Components/ProductLogo";
import React, {Fragment} from "react";
import styles from '@/../sass/webview/components/Validate.module.scss'
import {FormInput} from "@/Components/Controls";
import i18n from "i18next";
import Button from "@/Components/Button";
import ValidationErrors from "@/Components/ValidationErrors";

export default function Validate() {
    const organization = usePage().props.organization;

    const {data, setData, post, processing, errors} = useForm({
        password: '',
    });

    const onChange = (name, value) => {
        setData(name, value);
    };

    const submit = (e) => {
        e.preventDefault();

        post(route('webview.validate.store', organization.uuid))
    };

    return (
        <WebView>
            <Head title="Verify Password"/>
            <div>
                <ProductLogo />
                <form onSubmit={submit}>
                    <div className={styles.instructions}>{i18n.t("webview.validate.confirm-password")}</div>
                    <div className="row">
                        <ValidationErrors errors={errors}/>
                        <FormInput
                            format="password"
                            name="password"
                            isFocused={true}
                            autoComplete="current-password"
                            value={data.password}
                            onChange={onChange}
                            label={i18n.t("login.password")}
                            className="col-12"
                            dataQa="login-tab-password"
                        />
                    </div>
                    <div>
                        <Button className="w-100 btn btn-primary" processing={processing}>
                            {processing && <Fragment>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span className="visually-hidden">Loading...</span>
                            </Fragment>}
                            {!processing && i18n.t("webview.validate.submit")}
                        </Button>
                    </div>
                </form>
            </div>
        </WebView>
    )
}
